import Image from "next/image";

const THUMB = "/assets-next/tools/previews/svg/free-shipping-thumb.svg";

/**
 * Free-shipping threshold card inset (Figma 11097:39504 + slider/thumb siblings on 11043:70419).
 * Slider layers sit outside the white frame in Figma — coords converted to the 243×181 preview frame.
 */
export function FreeShippingThresholdPreview() {
  return (
    <div className="relative h-full w-full overflow-hidden">
      <div
        data-testid="free-shipping-threshold-canvas"
        className="relative h-[181px] w-[243px]"
      >
        <p className="absolute top-[15px] left-[19px] text-[12px] leading-[1.4] whitespace-nowrap">
          <span className="text-grey-500">Setting free shipping at</span>
          <span className="text-grey-950"> $70.00.</span>
        </p>

        <p className="text-grey-500 absolute top-[53px] left-[20px] text-[12px] leading-[1.2] tracking-[-0.04em]">
          Recommended $70.00
        </p>

        {/* Track — Figma 11097:39509 at card-relative 20×80, 215×12 */}
        <div
          aria-hidden
          className="absolute top-[80px] left-[20px] h-3 w-[215px] rounded-[10px] bg-[#f9f9f8]"
        />

        {/* Gradient fill — Figma 11097:39510 at 20×80, 134×12 */}
        <div
          aria-hidden
          className="absolute top-[80px] left-[20px] h-3 w-[134px] rounded-[140px] bg-gradient-to-r from-[#e6edff] to-[#5165ff]"
        />

        {/* Thumb — Figma 11097:39512 at 138×72, 27×27; asset expanded for drop shadow */}
        <div
          aria-hidden
          className="pointer-events-none absolute top-[72px] left-[138px] size-[27px]"
        >
          <div className="absolute inset-[-62.64%_-87.14%_-111.65%_-87.14%]">
            <Image
              src={THUMB}
              alt=""
              width={74}
              height={74}
              className="block size-full max-w-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
